/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function SilkModel(props) {
	const { nodes, materials } = useGLTF("models/silk.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.mesh_1.geometry}
				material={materials["Cotton pad muji.002"]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_WrapMaster001.geometry}
				material={materials["Red dot fabric.001"]}
				position={[-0.012, 0.333, -0.06]}
				rotation={[1.364, 0, 0]}
				scale={3.417}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.mesh019.geometry}
				material={materials["Fabric 27.001"]}
				position={[-0.002, 0.06, -0.034]}
				rotation={[0, Math.PI / 2, 0]}
				scale={0.708}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.mesh019_1.geometry}
				material={materials["Satin Fabric.001"]}
				position={[-0.002, 0.06, -0.034]}
				rotation={[0, Math.PI / 2, 0]}
				scale={0.708}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane104.geometry}
				material={materials["Fabric.004"]}
				position={[-0.105, 0.493, 1.305]}
				rotation={[0, 0.735, 1.257]}
				scale={[-0.9, 0.9, 0.9]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder021.geometry}
				material={materials["Floral Fabric.007"]}
				position={[0.038, -0.062, -0.03]}
				scale={[1.794, 0.023, 1.794]}
			/>
		</group>
	);
}

useGLTF.preload("models/silk.glb");
